// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: template.proto

import type { GenericTaskType } from './generic_task';

export const protobufPackage = 'compasspb';

/** TemplateTargetType defines the type of template content. */
export enum TemplateTargetType {
  TEMPLATE_TARGET_TYPE_UNSPECIFIED = 0,
  TEMPLATE_TARGET_TYPE_TEXT = 1,
  TEMPLATE_TARGET_TYPE_EMAIL = 2,
  TEMPLATE_TARGET_TYPE_GENERIC_TASK = 3,
  TEMPLATE_TARGET_TYPE_HTML = 4,
}

/** TextTemplate contains text message template data. */
export interface TextTemplate {
  content?: string | undefined;
}

/** EmailTemplate contains email template data. */
export interface EmailTemplate {
  subject?: string | undefined;
  body?: string | undefined;
}

/** HtmlTemplate contains HTML template data. */
export interface HtmlTemplate {
  content?: string | undefined;
}

/** GastroCreateTaskTemplate contains template data for creating a Gastro task. */
export interface GastroCreateTaskTemplate {
  subject?: string | undefined;
  message?: string | undefined;
}

/**
 * GenericTaskTemplate contains template data for a specific generic task type.
 * Only one task-type-specific field should be populated, matching task_type.
 */
export interface GenericTaskTemplate {
  task_type?: GenericTaskType | undefined;
  gastro_create_task?: GastroCreateTaskTemplate | undefined;
}

/**
 * TemplateTarget contains the template content based on target type.
 * Only one field should be populated based on the template's target_type.
 */
export interface TemplateTarget {
  text?: TextTemplate | undefined;
  email?: EmailTemplate | undefined;
  generic_task?: GenericTaskTemplate | undefined;
  html?: HtmlTemplate | undefined;
}

/** Template represents a template in the system. */
export interface Template {
  id?: string | undefined;
  organization_id?: string | undefined;
  program_id?: string | undefined;
  name?: string | undefined;
  slug?: string | undefined;
  description?: string | undefined;
  target_type?: TemplateTargetType | undefined;
  target?: TemplateTarget | undefined;
  created_by?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
  workflow_id?: string | undefined;
}

/** CreateTemplateRequest contains the information needed to create a new template. */
export interface CreateTemplateRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  target_type?: TemplateTargetType | undefined;
  target?: TemplateTarget | undefined;
  workflow_id?: string | undefined;
  slug?: string | undefined;
}

/** CreateTemplateResponse contains the newly created template with generated ID and timestamps. */
export interface CreateTemplateResponse {
  template?: Template | undefined;
}

/** GetTemplateRequest specifies which template to retrieve by its unique identifier. */
export interface GetTemplateRequest {
  organization_id?: string | undefined;
  template_id?: string | undefined;
}

/** GetTemplateResponse contains the requested template with all its details. */
export interface GetTemplateResponse {
  template?: Template | undefined;
}

/**
 * UpdateTemplateRequest specifies which template to update and what fields to change.
 * All fields except organization_id and template_id are optional. Only provided fields will be updated.
 */
export interface UpdateTemplateRequest {
  organization_id?: string | undefined;
  template_id?: string | undefined;
  program_id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  target_type?: TemplateTargetType | undefined;
  target?: TemplateTarget | undefined;
  workflow_id?: string | undefined;
}

/** UpdateTemplateResponse contains the updated template with modified fields and new timestamps. */
export interface UpdateTemplateResponse {
  template?: Template | undefined;
}

/** DeleteTemplateRequest specifies which template to permanently delete from the system. */
export interface DeleteTemplateRequest {
  organization_id?: string | undefined;
  template_id?: string | undefined;
}

/** DeleteTemplateResponse indicates whether the template deletion was successful. */
export interface DeleteTemplateResponse {
  success?: boolean | undefined;
}

/** ListTemplatesRequest specifies filtering and pagination options for retrieving templates. */
export interface ListTemplatesRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  target_type?: TemplateTargetType | undefined;
  limit?: number | undefined;
  start_after_id?: string | undefined;
  slug?: string | undefined;
  workflow_id?: string | undefined;
}

/** ListTemplatesResponse contains paginated list of templates matching the filter criteria. */
export interface ListTemplatesResponse {
  templates?: Template[] | undefined;
  next_cursor?: string | undefined;
}

/**
 * RenderTemplateRequest specifies the template to render and the context data sources.
 * At minimum, organization_id and template_id are required. Additional context (program_id,
 * case_record_id) provides more data for variable substitution.
 */
export interface RenderTemplateRequest {
  organization_id?: string | undefined;
  template_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /**
   * Caller-supplied context key-value pairs for template variable substitution.
   * These take precedence over auto-populated fields from organization, program, and case record.
   */
  context?: { [key: string]: string } | undefined;
}

export interface RenderTemplateRequest_ContextEntry {
  key: string;
  value: string;
}

/**
 * RenderTemplateResponse contains the rendered template content.
 * The response structure matches the template's target type with all variables substituted.
 */
export interface RenderTemplateResponse {
  /** The target type of the rendered template */
  target_type?: TemplateTargetType | undefined;
  /** Rendered content - only one field will be populated based on target_type */
  rendered?: RenderedTemplateTarget | undefined;
}

/**
 * RenderedTemplateTarget contains the rendered content based on target type.
 * Only one field will be populated based on the template's target_type.
 */
export interface RenderedTemplateTarget {
  text?: RenderedTextTemplate | undefined;
  email?: RenderedEmailTemplate | undefined;
  generic_task?: RenderedGenericTaskTemplate | undefined;
  html?: RenderedHtmlTemplate | undefined;
}

/** RenderedTextTemplate contains the rendered text message content. */
export interface RenderedTextTemplate {
  content?: string | undefined;
}

/** RenderedEmailTemplate contains the rendered email content. */
export interface RenderedEmailTemplate {
  subject?: string | undefined;
  body?: string | undefined;
}

/** RenderedHtmlTemplate contains the rendered HTML content. */
export interface RenderedHtmlTemplate {
  content?: string | undefined;
}

/** RenderedGastroCreateTaskTemplate contains the rendered Gastro create task content. */
export interface RenderedGastroCreateTaskTemplate {
  subject?: string | undefined;
  message?: string | undefined;
}

/** RenderedGenericTaskTemplate contains the rendered generic task content. */
export interface RenderedGenericTaskTemplate {
  task_type?: GenericTaskType | undefined;
  gastro_create_task?: RenderedGastroCreateTaskTemplate | undefined;
}

/**
 * TemplateService provides operations for managing templates within an organization.
 * Templates can be used for text messages, emails, or tasks, and can be scoped to
 * a specific program or be organization-wide.
 */
export interface TemplateService {
  /**
   * CreateTemplate creates a new template within an organization.
   * Templates can be scoped to a program (by providing program_id) or be organization-wide.
   * Returns the newly created template with generated ID and timestamps.
   */
  createTemplate(request: CreateTemplateRequest): Promise<CreateTemplateResponse>;
  /**
   * GetTemplate retrieves a template by its unique identifier.
   * Returns the complete template details including target-specific content.
   */
  getTemplate(request: GetTemplateRequest): Promise<GetTemplateResponse>;
  /**
   * UpdateTemplate modifies an existing template's metadata or content.
   * All fields except organization_id and template_id are optional.
   * Only provided fields will be updated.
   * Returns the updated template with new timestamps.
   */
  updateTemplate(request: UpdateTemplateRequest): Promise<UpdateTemplateResponse>;
  /**
   * DeleteTemplate permanently removes a template from the system.
   * Returns success status indicating whether the deletion was successful.
   */
  deleteTemplate(request: DeleteTemplateRequest): Promise<DeleteTemplateResponse>;
  /**
   * ListTemplates retrieves a paginated list of templates within an organization.
   * Supports filtering by program_id and target_type.
   * Returns templates matching the criteria.
   */
  listTemplates(request: ListTemplatesRequest): Promise<ListTemplatesResponse>;
  /**
   * RenderTemplate renders a template by substituting variables with actual data.
   * Uses context from organization, program, and case record to resolve template variables.
   * Variables that cannot be resolved are replaced with "N/A".
   * Returns the rendered content based on template target type.
   */
  renderTemplate(request: RenderTemplateRequest): Promise<RenderTemplateResponse>;
}
